import { render, staticRenderFns } from "./DataObjectCreateForm.vue?vue&type=template&id=044bdad9&"
import script from "./DataObjectCreateForm.vue?vue&type=script&lang=js&"
export * from "./DataObjectCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports